import { createEventHelpers, ISkyEventHelpers, SkyEvents } from '@skyeng/libs/shared/events';
import { IThread } from './models';
import { InjectionToken } from '@angular/core';

const trackingEvents = new SkyEvents({ group: 'commThreadListEvents' });

export const THREAD_LIST_EVENTS = new InjectionToken('commThreadListEvents');

interface OutGoingEvents {
  unreadCount: ISkyEventHelpers<number>;
  openThread: ISkyEventHelpers<IThread>;
  threadList: ISkyEventHelpers<ThreadListPayload>;
}

export interface ThreadListEvents {
  outgoing: OutGoingEvents;
}

interface ThreadInfo {
  threadId: number;
  serviceIds: number[];
}

interface ThreadListPayload extends Array<ThreadInfo> {}

export const threadListOutGoingEvents = {
  unreadCount: createEventHelpers<number>(trackingEvents, 'unreadCount'),
  openThread: createEventHelpers<IThread>(trackingEvents, 'openThread'),
  threadList: createEventHelpers<ThreadListPayload>(trackingEvents, 'threadList'),
};
